<template>
  <div class="questions-panel__container" id="questions_panel_container">
    <div
      v-bind:class="
        `questions-panel__inner` +
          (isFinished ? ` questions-panel__inner--finished` : ``)
      "
    >
      <div v-if="!isFinished">
        <div
          v-for="(section, section_index) in hcData.sections"
          v-bind:key="section_index"
        >
          <div
            v-for="(question, question_index) in section.questions"
            v-bind:key="section_index + `-` + question_index"
            v-bind:class="
              'questions-panel__question' +
                (isCurrentQuestion(question_index, section_index)
                  ? ' current'
                  : '')
            "
          >
            <div class="questions-panel__question__inner">
              <ProgressBar />
              <CloseButton />
              <h3 class="questions-panel__question__section-title">
                <span class="questions-panel__question__section-title__number"
                  >{{ section_index + 1 }}.</span
                >
                <span class="questions-panel__question__section-title__text">{{
                  section.section_title
                }}</span>
              </h3>
              <Question
                v-bind:question="question"
                v-bind:question_index="question_index"
                v-bind:section_index="section_index"
              ></Question>
            </div>
          </div>
        </div>
      </div>

      <Form />
    </div>
  </div>
</template>

<script>
import store from "../store";
import Question from "./Question";
import Form from "./Form";
import ProgressBar from "./ProgressBar";
import CloseButton from "./CloseButton";

export default {
  components: { CloseButton, ProgressBar, Question, Form },
  store: store,
  name: "Questions",
  methods: {
    isCurrentQuestion(question_number, section_number) {
      if (
        question_number === this.currentQuestionNumber &&
        section_number === this.currentSectionNumber
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  computed: {
    hcData() {
      return store.getters.hcData;
    },
    currentSectionNumber() {
      return store.getters.currentSectionNumber;
    },
    currentQuestionNumber() {
      return store.getters.currentQuestionNumber;
    },
    isFinished() {
      // return true;
      return store.getters.isFinished;
    }
  },
  mounted: function() {
    store.commit("nextQuestion");
  }
};
</script>

<style lang="scss">
.questions-panel {
  &__container {
    height: 100vh;
    overflow: hidden;
    position: relative;
  }

  &__inner {
    position: absolute;
    width: 100%;
    top: 0;
    transition: transform 0.6s ease;
    transform: translateY(0);
    padding-top: 85px;

    &--finished {
      transition: none;
    }

    @media (max-width: 767px) {
      padding-top: 0;
    }
  }

  &__question {
    height: 100vh;

    @media (max-width: 767px) {
      padding-top: 34.5px;
      padding-bottom: 20px;
    }

    .progress-bar {
      bottom: -37px;

      @media (max-width: 767px) {
        display: flex;
      }
    }

    &__inner {
      padding: 101px 39px 22px;
      background: linear-gradient(
        180deg,
        rgba(220, 220, 221, 1) 0%,
        rgba(220, 220, 221, 1) 29px,
        rgba(255, 255, 255, 1) 29px,
        rgba(255, 255, 255, 1) 100%
      );
      border-radius: 8px;
      position: relative;

      @media (max-width: 767px) {
        padding: 79px 18px 18px 18px;
      }
    }

    &__section-title {
      color: #0000ff;
      font-weight: 600;
      font-size: 26px;
      line-height: 28px;
      letter-spacing: -0.65;
      display: flex;

      @media (max-width: 767px) {
        font-size: 21px;
        line-height: 26px;
      }

      &__number {
        width: 44px;
        height: 47px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 19px;
        font-size: 26px;
        letter-spacing: -0.65px;

        background: {
          image: url("../../../assets/images/health-check-number-bg.svg");
          position: center;
          size: contain;
          repeat: no-repeat;
        }

        @media (max-width: 767px) {
          font-size: 21px;
          line-height: 22px;
          letter-spacing: -0.53px;
        }
      }

      &__text {
        display: block;
        margin-top: 13px;

        @media (max-width: 767px) {
          margin-top: 0;
        }
      }
    }
  }

  &__final {
    p {
      max-width: 556px;
      margin-top: 32px;
    }

    .questions-panel__question__inner {
      padding: 106px 10px 69px 72px;

      @media (max-width: 767px) {
        padding: 68px 0 0 0;
      }
    }

    .questions-panel__question__section-title {
      margin-bottom: 32px;
    }

    &__form {
      margin-top: 70px;
      display: flex;

      @media (max-width: 767px) {
        flex-direction: column;
      }

      @media (max-width: 767px) {
        margin-top: 20px;
      }

      &__fields {
        input {
          border: 1px solid #0000ff;
          border-radius: 6px;
          font-size: 14px;
          line-height: 17px;
          padding: 8px 10px 4px;
          width: 218px;
          margin-bottom: 12px;

          @media (max-width: 767px) {
            width: 100%;
          }

          &.error {
            border-color: red;
          }
        }
      }

      &__recaptcha {
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @media (max-width: 767px) {
          align-items: center;
          margin: 15px 0;
        }

        .recaptcha-error {
          color: #ff0100;
          font-size: 14px;
          margin-top: 8px;
        }

        .recaptcha-loading {
          color: #666;
          font-size: 14px;
          font-style: italic;
          padding: 10px;
          text-align: center;
        }
      }

      &__action {
        display: flex;
        flex: 1 0 auto;
        justify-content: center;

        button {
          background: transparent;
          border: 0px;
          font-size: 14px;
          color: #0000ff;
          line-height: 26px;
          font-weight: 600;
          cursor: pointer;

          @media (max-width: 767px) {
            background-color: #0000ff;
            color: white;
            border-radius: 6px;
            padding: 6px 10px 2px;
            width: 100%;
          }

          &:before {
            content: "";
            flex-basis: 70px;
            display: block;
            height: 90px;
            margin-bottom: 13px;
            background: {
              image: url("../../../assets/images/health-check-submit-button.svg");
              position: center;
              size: 70px;
              repeat: no-repeat;
            }

            @media (max-width: 767px) {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
